import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import {
  createNodeInspectorVisibleSlice,
  type NodeInspectorVisibleSlice,
} from '~/components/v2/store/features/devtools/slices/createNodeInspectorVisibleSlice';
import {
  createReactQueryDevtoolsVisibleSlice,
  type ReactQueryDevtoolsVisibleSlice,
} from '~/components/v2/store/features/devtools/slices/createReactQueryDevtoolsVisibleSlice';
import {
  createWorkspaceIdVisibleSlice,
  type WorkspaceIdVisibleSlice,
} from '~/components/v2/store/features/devtools/slices/createWorkspaceIdVisibleSlice';
import { ZustandStorageKeys } from '~/constants/zustandStorageKeys';

export type DevToolsState = WorkspaceIdVisibleSlice & ReactQueryDevtoolsVisibleSlice & NodeInspectorVisibleSlice;

export const useDevToolsStore = create<DevToolsState>()(
  persist(
    (...args) => ({
      ...createWorkspaceIdVisibleSlice({ workspaceIdVisible: false })(...args),
      ...createReactQueryDevtoolsVisibleSlice({ reactQueryDevtoolsVisible: false })(...args),
      ...createNodeInspectorVisibleSlice({ nodeInspectorVisible: false })(...args),
    }),
    {
      name: ZustandStorageKeys.DevTools,
      partialize: (state) => ({
        nodeInspectorVisible: state.nodeInspectorVisible,
        reactQueryDevtoolsVisible: state.reactQueryDevtoolsVisible,
        workspaceIdVisible: state.workspaceIdVisible,
      }),
      version: 2,
    },
  ),
);
